import React from 'react';
import './DobleBannerCL.css';

const banners = [
    {
        src: `${process.env.PUBLIC_URL}/imagenes/grandstream.jpg`,
        alt: 'Grandstream',
        href: '/marcas/GRS',
    },
    {
        src: `${process.env.PUBLIC_URL}/imagenes/yealink.jpg`,
        alt: 'Yealink',
        href: '/marcas/YLK',
    },
];

const DobleBannerCL = () => (
    <div className="doble-banner-cl">
        {banners.map((banner, index) => (
            <a
                key={index}
                className="doble-banner-cl__item"
                href={banner.href}
                rel="noopener noreferrer"
            >
                <img
                    className="doble-banner-cl__img"
                    src={banner.src}
                    alt={banner.alt}
                    loading="lazy"
                />
            </a>
        ))}
    </div>
);

export default DobleBannerCL;
